export enum JobErrorMessage {
  ErrorOccurred = "An error occurred. Please try again later!",
  JobNumberNotExist = "This Job number does not exist",
  AlreadyAssigned = "This Job is already assigned to Driver",
  AlreadySummitted = "This Job is already summitted",
  RequireInput = "Please enter a Job number",
  EverCompleted = "This job was at one point completed. Based on company settings, it can't be assigned."
}
